var render, staticRenderFns
import script from "./CalendarDay.vue?vue&type=script&lang=js&"
export * from "./CalendarDay.vue?vue&type=script&lang=js&"
import style0 from "./CalendarDay.vue?vue&type=style&index=0&id=005dafc8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005dafc8",
  null
  
)

export default component.exports